import {TicketHistoryBuyExtraSimpleVo} from '../../common/shared/api/nicolas/vo/TicketHistoryBuyExtraSimpleVo.interface';
import {TicketHistoryBuyExtraSimple} from '../generated/types';
import {createTicketStatus} from './TicketStatus';

export function createTicketHistoryBuyExtraSimple({
  product_id,
  title,
  status,
}: TicketHistoryBuyExtraSimpleVo): TicketHistoryBuyExtraSimple {
  return {
    productId: product_id,
    title,
    status: createTicketStatus(status),
  };
}
